import React from "react";
import about1 from "../resourcess/about us 1.jpeg";
import about2 from "../resourcess/Hero and about section/about us image 2.png";
import about3 from "../resourcess/About us image 3.jpeg";
import about4 from "../resourcess/about us image 4.jpeg";
import mirchi from "../resourcess/mirchi.png";

const About = () => {
  return (
    <section id="about" className="section about-section">
      <div className="section-inner">
        <div className="about-text">
          <h2 className="section-heading">About Us</h2>
          <p>
            At <span className="highlight-red">SRC Corporation</span>, we focus on sourcing and supplying <span className="highlight-red">premium dry red chillies from India</span>. With strong roots in family-run agricultural trading, we bring years of experience, reliability, and market expertise to every transaction.
          </p>
          <p>
            Based in <span className="highlight-red">Hyderabad</span>, we procure directly from leading mandi markets (wholesale markets), ensuring consistent quality and competitive pricing.
          </p>
          <p>
           Our strength lies in our deep understanding of the supply chain from procurement and quality control to logistics and timely delivery. We specialize in bulk trading and distribution, catering to wholesalers, food processors, exporters, and spice brands across India, including markets in Gujarat, Rajasthan, Delhi, and Maharashtra.
          </p>
          <img src={mirchi} alt="" className="mirchi-about-bl" aria-hidden="true" />
        </div>
        <div className="about-gallery">
          <img src={mirchi} alt="" className="mirchi-decor mirchi-about-tr" aria-hidden="true" />
          <img src={about1} alt="SRC Corporation sourcing" className="about-photo about-photo-1" />
          <img src={about2} alt="Chilli processing" className="about-photo about-photo-2" />
          <img src={about3} alt="Chilli fields" className="about-photo about-photo-3" />
          <img src={about4} alt="Team at chilli yard" className="about-photo about-photo-4" />
        </div>
      </div>
    </section>
  );
};

export default About;